import React from 'react'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import T from 'components/FormattedMessage'
import GameCardBottomInfoBar from '../GameCardBottomInfoBar'

interface Props {
  invited: number
  accepted: number
}

const styles = createStyles({
  status: {
    opacity: .5,
    fontSize: 10,
    fontWeight: 500,
    textTransform: 'uppercase',
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardBottomInfoBarInvite: React.SFC<InjectedProps> = ({
  classes,
  invited,
  accepted,
}) => {
  return (
    <GameCardBottomInfoBar>
      <Grid alignItems="center" justify="center" direction="row" container>
        <Grid item>
          <Typography className={classes.status}>
            <T id="game_acceptedinvite_format_plural" values={{ count: `${accepted} / ${invited}` }} />
          </Typography>
        </Grid>
      </Grid>
    </GameCardBottomInfoBar>
  )
}

export default withStyles(styles)(GameCardBottomInfoBarInvite)
